import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointUp } from '@lean-body/components/styles';
import SearchTitle from './search_title';
export const SearchLandingCircles = ({ title, items, onClick }) => {
    return (React.createElement("section", null,
        React.createElement(SearchTitle, null, title),
        React.createElement("div", { className: css(styles.circles) }, items.map((item) => (React.createElement("div", { key: item.id, className: css(styles.circleItem), onClick: () => onClick(item.id), "data-test": "searchKeyword" },
            React.createElement("img", { className: css(styles.circleImg), src: item.imageUrl, alt: "" }),
            React.createElement("span", { className: css(styles.circleLabel) }, item.name)))))));
};
const styles = StyleSheet.create({
    circles: {
        display: 'flex',
        flexWrap: 'nowrap',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '::-webkit-scrollbar': {
            width: 0,
            height: 0,
        },
        gap: 8,
        marginLeft: -16,
        marginRight: -16,
        paddingLeft: 16,
        [MediaBreakPointUp.MD]: {
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: 0,
            overflowX: 'hidden',
        },
        [MediaBreakPointUp.XL]: {
            flexWrap: 'wrap',
            overflowX: 'visible',
            columnGap: '20px',
            rowGap: '16px',
        },
    },
    circleItem: {
        width: 76,
        flexShrink: 0,
        padding: 0,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        [MediaBreakPointUp.MD]: {
            flex: '1 1 0',
            width: 'auto',
            minWidth: 0,
            maxWidth: 76,
        },
        [MediaBreakPointUp.XL]: {
            flex: '0 0 auto',
            width: 100,
            maxWidth: 'none',
        },
    },
    circleImg: {
        width: 70,
        height: 70,
        borderRadius: '50%',
        objectFit: 'cover',
        [MediaBreakPointUp.MD]: {
            width: '100%',
            height: 'auto',
            aspectRatio: '1',
        },
        [MediaBreakPointUp.XL]: {
            width: 100,
            height: 100,
        },
    },
    circleLabel: {
        width: '100%',
        fontSize: 12,
        lineHeight: '140%',
        textAlign: 'center',
        whiteSpace: 'pre-line',
    },
});
